module.exports = __webpack_public_path__ + "img/photo_consult_bg.cf3434df.png";